import React from 'react';
import PropTypes from 'prop-types';
import MoveMoneyBL from './MoveMoneyBL';
import HomepageBL from '../homepage/HomepageBL';

import {
  isCB,
  isYB,
  isBOrVMRetail,
  isVMBusiness,
} from '../../utils/BrandUtils';

// TODO: Join these together once Fragment is available
// Can't join with div or other as it breaks the CSS.
const AccountHolderLabel = () => (
  <dt className="account-card__data__name">Account Holder</dt>
);
const AccountHolder = ({ accountHolder }) => <dd>{accountHolder}</dd>;

const AccountNameLabel = () => (
  <dt className="account-card__data__name">Account name</dt>
);
const AccountName = ({ accountName }) => (
  <dd className="account-card__data__holder">{accountName}</dd>
);

const AccountNicknameLabel = () => (
  <dt className="account-card__data__name">Account Nickname</dt>
);
const AccountNickname = ({ accountName }) => (
  <dd className="account-card__data__holder">{accountName}</dd>
);

const AccountDisplayNumberLabel = ({ label }) => (
  <dt className="account-card__data__name">{label}</dt>
);
const AccountDisplayNumber = ({ accountDisplayNumber }) => (
  <dd className="account-card__number">{accountDisplayNumber}</dd>
);

const AccountTypeLabel = () => (
  <dt className="account-card__data__name">Account type</dt>
);
const AccountType = ({ accountName }) => (
  <dd className="account-card__type">{accountName}</dd>
);

const CurrentBalanceLabel = () => (
  <dt className="account-card__data__name">Current balance</dt>
);
const CurrentBalance = ({ currentBalance }) => (
  <dd className="account-card__balance">{currentBalance}</dd>
);

const ClearedBalanceLabel = ({ clearedBalance }) => (
  <dt className="account-card__data__name">Cleared balance</dt>
);
const ClearedBalance = ({ clearedBalance }) => (
  <dd className="account-card__balance">{clearedBalance}</dd>
);

const AvailableBalanceLabel = () => (
  <dt className="account-card__data__name">Account available balance</dt>
);
const AvailableBalance = ({ availableBalance }) => (
  <dd className="account-card__available-amt">{availableBalance}</dd>
);

const OverdraftBalanceLabel = () => (
  <dt className="account-card__data__name">Overdraft balance left</dt>
);
const OverdraftBalance = ({ overdraftBalance }) => (
  <dd className="account-card__available-amt">{overdraftBalance}</dd>
);

class SelectedAccountComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLargeCustomerView: isCB() || isYB() || isVMBusiness(),
      isBOrVMRetail: isBOrVMRetail(),
    };
  }

  getCreditCardText(accountName) {
    return accountName === 'CREDIT CARD' ? 'Credit Card number' : '';
  }

  render() {
    const { selectedAccount, componentName, selectedPotData } = this.props;
    const inputData = {
      accountHolder: selectedAccount.metadata.account_name,
      displayName: selectedAccount.metadata.display_name,
      accountName: selectedAccount.displayName,
      accountDisplayNumber:
        MoveMoneyBL.getAccountDisplayNumber(selectedAccount),
      currentBalance: MoveMoneyBL.currentAmount(selectedAccount),
      availableBalance: `${MoveMoneyBL.availableAmount(
        selectedAccount
      )} available`,
      clearedBalance: `${MoveMoneyBL.clearedAmount(selectedAccount)} cleared`, // TODOxCYBG will remove once it will come in service
      overdraftBalance:
        MoveMoneyBL.shouldShowArrangedOverdraft(selectedAccount) &&
        `${MoveMoneyBL.availableOverdraftAmount(
          selectedAccount
        )} arranged overdraft left`, // TODOxCYBG will remove once it will come in service
    };
    const { hasLargeCustomerView, isBOrVMRetail } = this.state;

    const shouldShowAvailableBalance =
      HomepageBL.shouldShowAvailableBalance(selectedAccount);

    const showAccountHolder = hasLargeCustomerView;
    const showAccountNickname = hasLargeCustomerView || isBOrVMRetail;
    const showAccountName = hasLargeCustomerView || isBOrVMRetail;
    const showClearedBalance = !shouldShowAvailableBalance;
    const showCurrentBalance = shouldShowAvailableBalance;
    const showOverdraftBalance = !shouldShowAvailableBalance;

    switch (componentName) {
      case 'componentA':
        return (
          <dl>
            {showAccountHolder && <AccountHolderLabel />}
            {showAccountHolder && (
              <AccountHolder accountHolder={inputData.accountHolder} />
            )}

            {showAccountNickname && <AccountNicknameLabel />}
            {showAccountNickname && (
              <AccountNickname accountName={inputData.accountName} />
            )}

            <AccountDisplayNumberLabel
              label={this.getCreditCardText(inputData.accountName)}
            />
            <AccountDisplayNumber
              accountDisplayNumber={inputData.accountDisplayNumber}
            />

            <AccountTypeLabel />
            <AccountType accountName={inputData.accountName} />

            {showCurrentBalance && <CurrentBalanceLabel />}
            {showCurrentBalance && (
              <CurrentBalance currentBalance={inputData.currentBalance} />
            )}

            {showClearedBalance && <ClearedBalanceLabel />}
            {showClearedBalance && (
              <ClearedBalance clearedBalance={inputData.clearedBalance} />
            )}

            {shouldShowAvailableBalance && <AvailableBalanceLabel />}
            {shouldShowAvailableBalance && (
              <AvailableBalance availableBalance={inputData.availableBalance} />
            )}

            {showOverdraftBalance && <OverdraftBalanceLabel />}
            {showOverdraftBalance && (
              <OverdraftBalance overdraftBalance={inputData.overdraftBalance} />
            )}
          </dl>
        );
      case 'componentB':
        return (
          <dl className="account-card__data">
            {showAccountHolder && <AccountHolderLabel />}
            {showAccountHolder && (
              <AccountHolder accountHolder={inputData.accountHolder} />
            )}

            {showAccountName && <AccountNameLabel />}
            {showAccountName && (
              <AccountName accountName={inputData.accountName} />
            )}

            <AccountDisplayNumberLabel
              label={this.getCreditCardText(inputData.accountName)}
            />
            <AccountDisplayNumber
              accountDisplayNumber={inputData.accountDisplayNumber}
            />

            {showCurrentBalance && <CurrentBalanceLabel />}
            {showCurrentBalance && (
              <CurrentBalance currentBalance={inputData.currentBalance} />
            )}

            {showClearedBalance && <ClearedBalanceLabel />}
            {showClearedBalance && (
              <ClearedBalance clearedBalance={inputData.clearedBalance} />
            )}

            {shouldShowAvailableBalance && <AvailableBalanceLabel />}
            {shouldShowAvailableBalance && (
              <AvailableBalance availableBalance={inputData.availableBalance} />
            )}

            {showOverdraftBalance && <OverdraftBalanceLabel />}
            {showOverdraftBalance && (
              <OverdraftBalance overdraftBalance={inputData.overdraftBalance} />
            )}
          </dl>
        );
      case 'componentC':
        return (
          <dl className="account-card__data">
            {showAccountHolder && <AccountHolderLabel />}
            {showAccountHolder && (
              <AccountHolder accountHolder={inputData.accountHolder} />
            )}

            {showAccountNickname && <AccountNicknameLabel />}
            {showAccountNickname && (
              <AccountNickname accountName={inputData.accountName} />
            )}

            <AccountDisplayNumberLabel
              label={this.getCreditCardText(inputData.accountName)}
            />
            <AccountDisplayNumber
              accountDisplayNumber={inputData.accountDisplayNumber}
            />

            <AccountTypeLabel />
            <AccountType accountName={inputData.accountName} />

            <dt className="account-card__data__name">Pot name</dt>
            <dd className="account-card__pot">Savings Pot Name</dd>

            <dt className="account-card__data__name">
              Account available balance
            </dt>
            <dd className="account-card__available-amt">
              <div>Savings Pot Balance Available</div>
            </dd>
          </dl>
        );
      case 'componentD':
        return (
          <dl className="account-card__data">
            {showAccountHolder && <AccountHolderLabel />}
            {showAccountHolder && (
              <AccountHolder accountHolder={inputData.accountHolder} />
            )}

            {showAccountName && <AccountNameLabel />}
            {showAccountName && (
              <AccountName accountName={inputData.accountName} />
            )}

            <AccountDisplayNumberLabel
              label={this.getCreditCardText(inputData.accountName)}
            />
            <AccountDisplayNumber
              accountDisplayNumber={inputData.accountDisplayNumber}
            />

            <dt className="account-card__data__name">Pot name</dt>
            <dd className="account-card__pot">{selectedPotData.name}</dd>

            {shouldShowAvailableBalance && <AvailableBalanceLabel />}
            {shouldShowAvailableBalance && (
              <AvailableBalance availableBalance={inputData.availableBalance} />
            )}
          </dl>
        );
      case 'componentE':
        return (
          <dl className="account-card__data">
            {showAccountHolder && <AccountHolderLabel />}
            {showAccountHolder && (
              <AccountHolder accountHolder={inputData.accountHolder} />
            )}

            {showAccountName && <AccountNameLabel />}
            {showAccountName && (
              <dd className="account-card__data__holder">
                {inputData.accountName}
              </dd>
            )}

            <AccountDisplayNumberLabel
              label={this.getCreditCardText(inputData.accountName)}
            />
            <AccountDisplayNumber
              accountDisplayNumber={inputData.accountDisplayNumber}
            />

            {showCurrentBalance && <CurrentBalanceLabel />}
            {showCurrentBalance && (
              <CurrentBalance currentBalance={inputData.currentBalance} />
            )}

            {showClearedBalance && <ClearedBalanceLabel />}
            {showClearedBalance && (
              <ClearedBalance clearedBalance={inputData.clearedBalance} />
            )}

            {shouldShowAvailableBalance && <AvailableBalanceLabel />}
            {shouldShowAvailableBalance && (
              <AvailableBalance availableBalance={inputData.availableBalance} />
            )}

            {showOverdraftBalance && <OverdraftBalanceLabel />}
            {showOverdraftBalance && (
              <OverdraftBalance overdraftBalance={inputData.overdraftBalance} />
            )}
          </dl>
        );
      default:
        break;
    }
  }
}

SelectedAccountComponent.propTypes = {
  componentName: PropTypes.string,
  selectedAccount: PropTypes.shape({}),
  selectedPotData: PropTypes.shape({}),
};

SelectedAccountComponent.defaultProps = {
  componentName: '',
  selectedAccount: {},
  selectedPotData: {},
};

export default SelectedAccountComponent;
